// export type AppParamListProps =
//   | AdminDashboardEventsProps
//   | CommunityScreenProps
//   | EmailLoginScreenProps
//   | FullEventScreenProps
//   | FullEventConfirmationScreenProps
//   | GuestListScreenProps
//   | LoginScreenProps
//   | OrganizersPageScreenProps
//   | ProfileEventsScreenProps
//   | ProfileFinalScreenProps
//   | ProfileFinalPathScreenProps
//   | QrCodeScreenProps
//   | SubscriptionPlanScreenProps
//   | SubscriptionCheckoutScreenProps
//   | SubscriptionMarkitNumberScreenProps
//   | SubscriptionCancelScreenProps;

export enum NavigationId {
  COMMUNITY = "/community",
  EMAIL_LOGIN = "/login/email",
  EVENT_QR_CODE = "/",
  EXPLORE = "/explore",
  FULLEVENT_FINAL = "/e/:eventId/i/:userId",
  GUEST_LIST = "/e/:eventId/guestlist",
  HOME = "/home/*",
  HOME_PROFILE = "/home/profile",
  HOME_CONTACTS = "/home/contacts",
  HOME_DATA_QUESTIONS = "/home/data-questions",
  HOME_MEMBERSHIPS = "/home/memberships",
  HOME_LISTS = "/home/lists",
  HOME_IMPORT = "/home/import",
  HOME_INTEGRATIONS = "/home/integrations",
  HOME_PRODUCTS = "/home/products",
  HOME_PAYOUTS = "/home/payouts",
  HOME_TRACKING_LINKS = "/home/tracking-links",
  HOME_AUTO_DM = "/home/auto-dm",
  HOME_SUBSCRIBE_FORM = "/home/subscribe-form",
  HOME_TEXTING = "/home/texting",
  HOME_CONVERSATIONS = "/home/conversations",
  HOME_SETTINGS = "/home/settings",
  HOME_FINISH_ONBOARDING = "/home/finish-onboarding",
  HOME_ACCOUNT_STATUS = "/home/account-status",
  HOME_REFERRAL_PROGRAM = "/home/referral-program",
  NEW_PRODUCT = "/new-product",
  IMPORT = "/import",
  INTEGRATIONS = "/integrations",
  OAUTH_CONSENT = "/oauth/consent",
  ONBOARDING = "/onboarding",
  ORGANIZERSPAGE = "/e/:eventId/i/:userId/organizers",
  PROFILE_EVENTS = "/u/:username/eventlist",
  PROFILE_FINAL = "/u/:username",
  QR_CODE = "/",
  SECONDARY_ONBOARDING = "/secondary-onboarding",
  SIGN_IN = "/signIn",
  SUBSCRIPTION_PLAN = "/subscription/*",
  WELCOME = "/welcome",
}

export enum NewProductNavigationId {
  EVENT = "/new-product/event",
  WEBINAR = "/new-product/webinar",
  LINK_EVENT = "/new-product/link-event",
  POST = "/new-product/post",
  VIDEO = "/new-product/video",
  AUDIO = "/new-product/audio",
  IMAGE = "/new-product/image",
  PDF = "/new-product/pdf",
}

export enum LandingPageNavigationId {
  TEXTING = "/texting",
  MONETIZATION = "/monetization",
  PRESS_MEDIA = "/press",
  PRICING = "/pricing",
  STRIPE_SUCCESSFUL = "/stripesuccessful",
  INSTAGRAM_CONNECTION = "/instagram/connection",
  FACEBOOK_CONNECTION = "/facebook/connection",
  GOOGLE_CALENDAR_CONNECTION = "/google-calendar/connection",
}

export const LandingPageSourceLabels: Record<string, string> = {
  "/": "Home",
  [LandingPageNavigationId.TEXTING]: "Texting",
  [LandingPageNavigationId.MONETIZATION]: "Monetization",
  [LandingPageNavigationId.PRICING]: "Pricing",
  [NavigationId.HOME]: "Creator Home",
};

export interface FullEventConfirmationProps {
  id: NavigationId.FULLEVENT_FINAL;
}

export type AppParamList = {
  Login: undefined;
  FullEventConfirmation: {
    eventId: string;
    userId: string;
  };
};
